cv.TeamProjectsView = Marionette.CompositeView.extend({
  template : cv.Templates['team/projects'],
  childViewContainer: '.team-list',
  childView: cv.TeamProjectsRowView,
  emptyView: cv.TeamProjectsRowEmptyView,

  events: {
  },

  behaviors: [],

  childEvents: {
    'show' : function() {
    },
    'render' : function() {
    }
  },

  collectionEvents: {
    'sync' : 'collectionSync'
  },

  childViewOptions: function(model, index) {
    // do some calculations based on the model
    return {
      team_model : this.model
    }
  },

  initialize: function(options){
    this.mergeOptions(options, this.options);

    console.log('TeamProjectsView initialized');
  },

  isEmpty: function(collection){
    console.log(collection);
    if(collection.num_records > 0 || _.isUndefined(collection.num_records)){
      return false;
    }
    if(collection.num_records == 0){
      return true;
    }
  },

  collectionSync: function(collection){
    // Fire imgix
    if(this.$('.imgix-fluid').length > 0){
      imgix.fluid(this.$el.get(0), {
        updateOnResizeDown: false,
        pixelStep: 5,
        autoInsertCSSBestPractices: true
      });
    }
  },

  attachHtml: function(collectionView, childView, index){
    if (collectionView.isBuffering) {
      // buffering happens on reset events and initial renders
      // in order to reduce the number of inserts into the
      // document, which are expensive.
      collectionView._bufferedChildren.splice(index, 0, childView);
    }else {
      // If we've already rendered the main collection, append
      // the new child into the correct order if we need to. Otherwise
      // append to the end.
      if (!collectionView._insertBefore(childView, index)){
        collectionView._insertAfter(childView);
      }
    }
  },

  templateHelpers: function(){
    return {
      team_id : this.model.get('id')
    }
  },

  onBeforeShow: function(){
  },

  onAttach: function(){ 
    this.collection.fetch({
      reset: true
    });
  },

  onDestroy: function(){
  }
});